import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-pin',
  standalone: false,
  templateUrl: './add-pin.component.html',
  styleUrl: './add-pin.component.scss'
})
export class AddPinComponent implements OnInit {
  fb = inject(FormBuilder);
  readonly dialog = inject(MatDialogRef<AddPinComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  agent: any;
  topic: string = "";
  content: string = "";
  edited: boolean = false;


  ngOnInit(): void {
    this.agent = this.data?.agent
    if (this.data.topic) this.topic = this.data.topic;
    if (this.data.content) this.content = this.data.content;
    if (this.data.edit) this.edited = this.data.edit;
  }

  adddEntry() {
    this.topic = this.topic.trim();
    this.content = this.content.trim();



    if (this.topic == "" || this.content == "") {
      return;
    }
    let edited = false;
    if (this.data.edit === true) { edited = true; }
    console.log(this.topic, this.content, edited);

    this.dialog.close({
      topic: this.topic, content: this.content, edited
    })
  }

  close() {
    this.dialog.close();
  }

}
